module.exports = __webpack_public_path__ + "assets/img/natrium-3.0b299b8dbbb58b8553230e273f93d053.png";